export default __webpack_public_path__ + "branding.svg?c98dab5678238fb19eb316feb1f0115d";